import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Message} from "primeng/api";
import {IFlow} from "../../../../../data/interfaces/iflow.interface";
import {ApiFlowDataService} from "../../../../../data/services/api/flow/api-flow-data.service";
import {LoaderService} from "../../data/services/page/loader.service";
import {ApiWorkerService} from "../../data/services/api/api-worker.service";
import { FormControl, Validators } from '@angular/forms';


@Component({
  selector: 'app-account-validation-component',
  templateUrl: './account-validation-component.component.html',
  styleUrls: ['./account-validation-component.component.scss']
})
export class AccountValidationComponentComponent  implements OnInit {
  responseMessage: Message[] = []
  showMessage = false
  startButtonIsAvailable = true
  clabeControl = new FormControl('', [
    Validators.required,
    Validators.pattern(/^\d{18}$/)
  ]);
  otpControl = new FormControl('', [
    Validators.required,
    Validators.pattern(/^\d{2}$/)
  ]);
  step: 'CLABE' | 'OTP' | 'CONFIRM' = 'CLABE';
  otpRequired = false;
  slug = '';
  account_uuid = '';
  workerId = '';
  clabe = '';
  @Input() data!: IFlow
  @Output() onEndProcess = new EventEmitter()
  @Output() onUpdateStage = new EventEmitter()
  startedProcess = false
  constructor(
    private flowDataService: ApiFlowDataService,
    private loaderService: LoaderService,
    private workerApiService: ApiWorkerService
  ) {
  }
  async ngOnInit() {
console.log("dataaaaa",this.data)
  }

  confirmCompletedProcess() {
    this.loaderService.showSpinner();
      this.flowDataService.updateSessionStatusAndStage(this.workerId, this.data.properties, this.clabe).subscribe(r => {
        this.loaderService.hideSpinner();

        this.responseMessage = [{
          summary: r.msg,
          severity: r.error ? 'error' : 'success',
          closable: false,
        }];

        if (!r.error) {
          setTimeout(() => this.onEndProcess.emit(true), 1500);
        } else {
          this.onUpdateStage.emit();
        }
      });
  }


  async start() {
    if (this.clabeControl.invalid) {
      this.clabeControl.markAsTouched();
      return;
    }

    this.loaderService.showSpinner();

    this.workerApiService.getWorkerId().subscribe(workerRes => {
      if (workerRes.error || !workerRes.data?.workerId) {
        this.loaderService.hideSpinner();
        this.responseMessage = [{
          summary: workerRes.msg || 'No se pudo obtener el ID del trabajador',
          severity: 'error',
          closable: false
        }];
        return;
      }

      this.workerId = workerRes.data.workerId;
      this.clabe = String(this.clabeControl.value);
      const body = {
          workerId: this.workerId,
          accountNumber: this.clabe
      };

      this.flowDataService.connectAccount(body).subscribe(r => {
        this.loaderService.hideSpinner();

        if (!r.error) {
          this.slug = String(r.data.slug);
          this.account_uuid = String(r.data.account_uuid);
          this.otpRequired = true;
          this.startButtonIsAvailable = false;
          this.responseMessage = [{
            summary: 'Proceso iniciado. Ingresa el código OTP.',
            severity: 'success',
            closable: false
          }];
          this.step = 'OTP';
        } else {
          this.responseMessage = [{
            summary: r.msg,
            severity: 'error',
            closable: false
          }];
        }
      });
    });
  }

  validateOtp() {
    if (this.otpControl.invalid) {
      this.otpControl.markAsTouched();
      return;
    }

    const otp = Number(this.otpControl.value);
    this.loaderService.showSpinner();

    this.flowDataService.authenticateAccount({
      slug: this.slug,
      account_uuid: this.account_uuid,
      otp
    }).subscribe(res => {
      this.loaderService.hideSpinner();
      console.log('✅ OTP response:', res);


      if (!res.error) {
        this.responseMessage = [{
          summary: res.msg,
          severity: res.error ? 'error' : 'success',
          closable: false
        }];

        this.step = 'CONFIRM';
        this.startedProcess = true;
      } else {
        this.onUpdateStage.emit();
      }
    });
  }

  /*validateUserIdentity() {
    console.log("validating")
    this.loaderService.showSpinner()
    setTimeout(() => {
      this.flowDataService.validateIneValidationStatus({idDocument: this.data.id, idStage: this.data.userDocumentId}).subscribe(r => {
        this.loaderService.hideSpinner()
        this.responseMessage = [
          {
            summary: r.msg,
            severity: r.error ?  'error': 'success',
            closable: false,
          }
        ]
        if (!r.error) {
          setTimeout(() => {
            this.onEndProcess.emit(true)
          }, 2000)
        } else this.onUpdateStage.emit()
      })
    }, 5000)

  }*/
}
